"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const __1 = require("../../../..");
const constants_1 = require("../../../../tasks/constants");
const TaskPage_1 = require("../../base/TaskPage");
const autosave_1 = require("../../../../hooks/autosave");
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const styled_1 = __importDefault(require("@emotion/styled"));
const api_1 = __importDefault(require("../../../../api"));
const ValidationContext_1 = require("../../../../context/ValidationContext");
const actionCallback_1 = require("../../../../hooks/actionCallback");
const MarginWrapper_1 = require("../../../components/margin/MarginWrapper");
const StyledExternalTaskContainer = styled_1.default.div `
	:not(.handlebar__row),
	p,
	.accordion__header-text {
		font-family: ${merlin_theme_1.default.typography.fonts.base} !important;
	}

	p {
		margin: ${merlin_theme_1.default.layout.spacing.standard} 0;
	}

	.merlin-button {
		background-color: ${merlin_theme_1.default.colours.neutral.light};
	}

	.tag--warning {
		background: unset;
		background-color: #c9365b !important;
	}

	.tag--success {
		background: unset;
		background-color: #0d8667 !important;
	}

	.accordion__header:nth-of-type(1) {
		display: none;
	}

	.accordion__item:nth-of-type(2) {
		padding-top: 0px;
	}

	.accordion__item,
	.accordion__header {
		padding-left: 0px;
		padding-right: 0px;
	}

	.property-edit-photos-buttons {
		display: block;
	}
`;
// IMAGES_GET_BY_PROPERTY_ID_RECEIVE is the trigger the Airbnb import uses to update images
const PHOTOS_CHANGED_ACTIONS = ['IMAGES_UPLOAD_RECEIVE', 'IMAGES_DELETE_FROM_PROPERTY_RECEIVE', 'IMAGES_GET_BY_PROPERTY_ID_RECEIVE'];
exports.default = (props) => {
    const { photosTask } = React.useContext(__1.AppContext);
    const { dispatch: validationDispatch } = React.useContext(ValidationContext_1.ValidationContext);
    const { viewState, property } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    (0, actionCallback_1.useActionCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const validationResp = yield api_1.default.client.getImageValidation(props.propertyId);
        validationDispatch(ValidationContext_1.validationActions.updateImages(validationResp.count, validationResp.valid));
    }), ...PHOTOS_CHANGED_ACTIONS);
    return React.createElement(TaskPage_1.TaskPage, { task: constants_1.Tasks.PHOTOS, property: property, viewState: viewState },
        React.createElement(MarginWrapper_1.MarginWrapper, null,
            React.createElement(StyledExternalTaskContainer, null, photosTask(props.propertyId))));
};
//# sourceMappingURL=PhotosPage.js.map